import swal from "sweetalert";

import { loadJsZipFromCache, loadJsZipFromWeb } from "./loader";
import {
  getGeometryFromStl,
  getGeometryFromGlb,
} from "@/components/geometry/geometryLoader.js";
import {
  checkPatientIsRestitching,
  getLastStitchingResult,
} from "@/api/toothApi";

let StitchedTeeth = [];

async function checkIsStitched() {
  let stitchedZipUrl = null;
  try {
    // console.log("checkIsStitched");
    let arr = vueApp.jsonLocation.split("/");
    arr.pop();
    const index = arr.indexOf("STL");
    arr.splice(index, 1);
    arr.splice(index + 1, 0, "stlCopy");

    let stlCopyUrl = arr.join("/");
    arr.push("mobile.zip");
    stitchedZipUrl = arr.join("/");

    let response = await fetch(stitchedZipUrl, { method: "HEAD" });
    if (response.status === 200) {
      vueApp.isStitched = true;
      vueApp.stlCopyUrl = stlCopyUrl;
    }
  } catch (error) {
    console.log("case is not stitched", stitchedZipUrl);
  }
}

async function loadStitchedTeeth(ignoreCache) {
  if (!vueApp.isStitched) return;
  console.log("loadStitchedTeeth");
  const stitchedZipFile = vueApp.zipFile.replace(
    vueApp.stlBaseUrl,
    vueApp.stlCopyUrl // stlBaseUrl stlCopyUrl
  );

  let zip = !ignoreCache ? await loadJsZipFromCache(stitchedZipFile) : null;
  if (!zip) {
    zip = await loadJsZipFromWeb(stitchedZipFile, false);
  }
  if (zip) {
    let models = await processStitchedZip(zip);
    await processStitchedTeeth(models, zip.isGlb);
  }
}

async function processStitchedZip(zip) {
  if (zip) {
    let filesCount = Object.entries(zip.files).length;
    if (filesCount == 0) {
      return;
    }
    let models = [];
    let allItems = vueApp.allTeeth;

    for (const item of allItems) {
      try {
        let fileName = item.filename;
        if (!isFalsyOrSpaces(fileName)) {
          if (zip.isGlb)
            fileName = fileName.replace(new RegExp(".stl$"), ".glb");
          let zipFile = zip.file(fileName);
          if (zipFile) {
            let buffer = await zipFile.async("arraybuffer");
            let elementGeometry = zip.isGlb
              ? await getGeometryFromGlb(buffer)
              : getGeometryFromStl(buffer);
            let model = {
              id: item.id,
              color: item.color,
              opacity: item.opacity,
            };
            model.geometry = elementGeometry;
            model.item = item;
            models.push(model);
          }
        }
      } catch (error) {
        console.log("processStitchedZip error for item", item, error);
      }
    }

    return models;
  }
}

async function processStitchedTeeth(stitchedModels, isGlb) {
  console.log("processStitchedTeeth", stitchedModels);

  if (!StitchedTeeth) StitchedTeeth = [];

  for (const model of stitchedModels) {
    let elementGeometry = model.geometry ? model.geometry : null;
    if (!elementGeometry && model.mesh) {
      elementGeometry = model.mesh.geometry;
    }
    if (!elementGeometry) {
      elementGeometry = isGlb
        ? await getGeometryFromGlb(model.local_file)
        : getGeometryFromStl(model.local_file);
    }
    let stitchedTooth = StitchedTeeth.find((t) => t.item == model.item);
    if (!stitchedTooth) {
      stitchedTooth = model;
      StitchedTeeth.push(stitchedTooth);
    }
    stitchedTooth.geometry = elementGeometry;
    stitchedTooth.stitchedGeometry = null;
  }
}

function switchStitching(sourceType) {
  // TODO: FIX NAMING cbctGeometry stitchedGeometry
  if (StitchedTeeth && StitchedTeeth.length > 0) {
    vueApp.viewSourceType = sourceType;
    // console.log("switchStitching", sourceType, StitchedTeeth);
    for (const stitchedTooth of StitchedTeeth) {
      let item = stitchedTooth.item;
      let mesh = viewer.get_model_mesh(item.id);
      stitchedTooth.cbctGeometry = mesh.cbctGeometry;
      if (!stitchedTooth.cbctGeometry) {
        stitchedTooth.cbctGeometry = mesh.geometry;
      }

      if (!stitchedTooth.stitchedGeometry) {
        let stitchedGeometry = stitchedTooth.geometry;
        let matrix2 = new THREE.Matrix4();
        matrix2.makeRotationAxis(new THREE.Vector3(0, 1, 0), rotateY);
        stitchedGeometry.applyMatrix4(matrix2);
        let matrix1 = new THREE.Matrix4();
        matrix1.makeRotationAxis(new THREE.Vector3(1, 0, 0), rotateX);
        stitchedGeometry.applyMatrix4(matrix1);
        // stitchedGeometry.center();

        let defaultBox = item.defaultBox; //offsetBox(stitchedTooth.defaultBox);
        stitchedGeometry.translate(
          -defaultXOffset - defaultBox.center.x,
          -defaultYOffset - defaultBox.center.y,
          -defaultZOffset - defaultBox.center.z
        );
        stitchedGeometry.computeBoundingBox();
        mesh.stitchedBox = offsetBox(stitchedGeometry.boundingBox);
        // console.log("stitchedBox", item.filename, mesh.stitchedBox.center);

        let geometry = new THREE.Geometry().fromBufferGeometry(
          stitchedGeometry
        );
        geometry.mergeVertices();
        geometry.computeVertexNormals();
        geometry = new THREE.BufferGeometry().fromGeometry(geometry);
        geometry.computeBoundingBox();
        stitchedTooth.stitchedGeometry = mesh.stitchedGeometry = geometry;
      }
      stitchedTooth.stitchedGeometry = mesh.stitchedGeometry;

      mesh.geometry =
        sourceType === "cbct"
          ? stitchedTooth.stitchedGeometry
          : stitchedTooth.cbctGeometry; // stitchedGeometry cbctGeometry
      // console.log(stitchedModel.filename, stitchedModel.geometry);
    }
  }
}

//#region Postprocess

const postprocessInterval = 30000;
let postprocessVar = null;

function startIsStitchingWatch() {
  // console.log("startIsStitchingWatch");
  isStitchingCheck();
  postprocessVar = setInterval(isStitchingCheck, postprocessInterval);
}

function stopIsStitchingWatch() {
  clearInterval(postprocessVar);
}

async function isStitchingCheck() {
  // console.log(new Date(), "isStitchingCheck");
  try {
    if (!vueApp.isSaving) {
      let isStitching = await checkPatientIsRestitching(vueApp.patientId);
      if (!isStitching && vueApp.isStitching && !vueApp.isSaving) {
        vueApp.lastStitchingResult = await getLastStitchingResult(
          vueApp.patientId
        );

        if (!vueApp.isAnnotationMode) {
          displayLastStitchingResult();
        }
      }
      vueApp.isStitching = isStitching;
    }
  } catch (error) {
    console.error("isStitchingCheck", error);
  }

  // console.log("isStitchingCheck", vueApp.isStitching);
}

function displayLastStitchingResult() {
  if (vueApp.lastStitchingResult) {
    console.log("displayLastStitchingResult", vueApp.lastStitchingResult);
    let resultValue = vueApp.lastStitchingResult.value;
    if (resultValue) {
      swal({
        text: "Stitching succeed. Do you want to reload stitched teeth?",
        buttons: {
          yes: { text: "Yes", value: true },
          no: { text: "No", value: false },
        },
      }).then(async (willReload) => {
        if (willReload) {
          showLoaderPopup();
          try {
            // TO FIX
            // await loadStitchedTeeth(true);
            // vueApp.viewSourceType = "stitched";
            // switchStitching(vueApp.viewSourceType);
          } catch (error) {
            console.log("reloadStitchedTeeth error", error);
          }
          $id("loader").style.display = "none";
        }
      });
    } else if (resultValue == null) {
      swal({
        text: "Can't get stitching result. Please contact support@cephx.com.",
      });
    } else {
      swal({
        text: "Stitching failed. Please contact support@cephx.com.",
      });
    }

    vueApp.lastStitchingResult = null;
  }
}

function showLoaderPopup() {
  $id("loader").style.display = "block";
  $id("loader").style.background = "gray";
  $id("loader").style.opacity = "0.7";
  $("#loaderText").html(`Loading...`);
  $("#loaderText2").html(` Just a few more seconds `);
  $("#loaderText3").html(``);
}

//#endregion

export {
  StitchedTeeth,
  loadStitchedTeeth,
  checkIsStitched,
  switchStitching,
  startIsStitchingWatch,
  stopIsStitchingWatch,
  displayLastStitchingResult,
};
